const Video = ({width = 600, height = 600}) => <video preload="auto" style={{display: "none"}}>
  <source src="/spin.webm" type="video/webm"/>
  <source src="/spin.mov" type="video/quicktime"/>
</video>;

export default Video
